import React from 'react';
import { Link } from 'react-router-dom';
import './LostPage.css';

export default function LostPage() {
  return (
    <section className="lost-page">
      <div className="lost-container">
        <h1 className="lost-title">404</h1>
        <h2 className="lost-subtitle">You seem lost!</h2>
        <p className="lost-description">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn btn-primary btn-large">
          Go Home
        </Link>
      </div>
    </section>
  );
}
